/**
 * Returns the JWT's `exp` claim as an ms-epoch timestamp, or 0 if the
 * token is malformed or missing the claim. Never throws.
 *
 * Handles base64url (with `-` / `_` and no padding) by normalizing to
 * standard base64 before decoding.
 */
export function decodeJwtExp(token: string): number {
  const parts = token.split('.');
  if (parts.length !== 3) return 0;
  try {
    const b64url = parts[1];
    const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    const payload = JSON.parse(json) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : 0;
  } catch {
    return 0;
  }
}
